import * as native from './native'

export async function printText(device, text) {
  const res = await native.call('printer.printText', device, text)
  return res
}
